import {
  API_METHOD,
  BASE_URL,
  HOST_URL,
  REQUEST_URL,
} from "../constants/constants";
import { interceptor } from "../interceptor/interceptor";

export const adminSignIn = async (body) => {
  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.login,
      data: body,
      contentType: "application/json",
      // headers:{Authorization:`Bearer ${token}`}
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const followUp = async (body) => {
  let token = localStorage.getItem("api-token");

  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.followUp,
      data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateAdminEmployee = async (body) => {
  let token = localStorage.getItem("api-token");

  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.updateLicenseCount,
      data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateAssignee = async (body) => {
  let token = localStorage.getItem("api-token");

  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.assignRepresentative,
      data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const adminEmployeeAccess = async (body) => {
  let token = localStorage.getItem("api-token");

  try {
    let response = await interceptor({
      method: API_METHOD.put,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.organizationAccess,
      data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const demoIncrease = async (body) => {
  let token = localStorage.getItem("api-token");

  try {
    let response = await interceptor({
      method: API_METHOD.put,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.updateDemoLicense,
      data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const discountUpdate = async (body) => {
  let token = localStorage.getItem("api-token");

  try {
    let response = await interceptor({
      method: API_METHOD.put,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.giveDiscount,
      data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const userDetailsAdmin = async (body) => {
  let token = localStorage.getItem("api-token");
  try {
    let response = await interceptor({
      method: API_METHOD.get,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.profile,
      // data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAdminList = async (body) => {
  let token = localStorage.getItem("api-token");
  try {
    let response = await interceptor({
      method: API_METHOD.get,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.allAdmins,
      // data: body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const organizationList = async (body) => {
  let token = localStorage.getItem("api-token");
  try {
    let response = await interceptor({
      method: API_METHOD.get,
      url: HOST_URL.url + BASE_URL.adminUrl + REQUEST_URL.organizations,
      // data:body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const referalList_Api = async (email) => {
  let token = localStorage.getItem("api-token");
  try {
    let response = await interceptor({
      method: API_METHOD.get,
      url: HOST_URL.urlMobile + BASE_URL.referalUrl + REQUEST_URL.allusers + `?email=${email}`,
      // data:body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const markRequest_API = async (body,email) => {
  let token = localStorage.getItem("api-token");
  try {
    let response = await interceptor({
      method: API_METHOD.put,
      url: HOST_URL.urlMobile + BASE_URL.referalUrl +BASE_URL.adminUrl + REQUEST_URL.clearInvoice + `?email=${email}`,
      data:body,
      contentType: "application/json",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

